import React from "react";

import CommonSection from "../components/UI/common-section/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import "../styles/cart-page.css";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import { cartActions } from "../store/shopping-cart/cartSlice";
import { Link } from "react-router-dom";

const Cart = () => {
  const cartItems = useSelector((state) => state.cart.cartItems);
  const totalAmount = useSelector((state) => state.cart.totalAmount);
  return (
    <Helmet title="Cart">
      <CommonSection title="Savatcha" />
      <section>
        <Container>
          <Row>
            <Col lg="12">
              {cartItems.length === 0 ? (
                <h5 className="text-center">Savatcha bo'sh </h5>
              ) : (
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Rasmi</th>
                      <th>Nomi</th>
                      <th>Narxi</th>
                      <th>Miqdori</th>
                      <th>Olish</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cartItems.map((item) => (
                      <Tr item={item} key={item.id} />
                    ))}
                  </tbody>
                </table>
              )}

              <div className="mt-4">
                <h6>
                 Jami: 
                  <span className="cart__subtotal"> {totalAmount}</span> so'm
                </h6>
               
                <div className="cart__page-btn">
                  
                  <button className="addTOCart__btn">
                    <Link to="/login"> <h5 className="text-center">Keyingi</h5></Link>
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

const Tr = (props) => {
  const { id, image01, title, price, quantity } = props.item;
  const dispatch = useDispatch();

  const deleteItem = () => {
    dispatch(cartActions.deleteItem(id));
  };
  return (
    <tr>
      <td className="text-center cart__img-box">
        <img className="w-100  h-100" src={image01} alt="" />
      </td>
      <td className="text-center">{title}</td>
      <td className="text-center">{price} so'mdan</td>
      <td className="text-center">{quantity} dona</td>
      <td className="text-center cart__item-del">
        <i class="ri-delete-bin-line" onClick={deleteItem}></i>
      </td>
    </tr>
  );
};

export default Cart;
